export const UNSET = 'unset'

export const FERTILITY = 'fertility'
export const MENOPAUSE = 'menopause'
export const PREGNANCY_AND_POSTPARTUM = 'pregnancy_and_postpartum'
export const SACTIONED_COUNTRIES = [
  'Afghanistan',
  'Albania',
  'Armenia',
  'Azerbaijan',
  'Syria',
  'Belarus',
  'Bosnia & Herzegovina',
  'Burma',
  'Burundi',
  'Central African Republic',
  'China',
  'Egypt',
  'Ethiopia',
  'Guinea',
  'Guinea-Bissau',
  'Haiti',
  'Iraq',
  'Ivory Coast',
  'Kosovo',
  'Lebanon',
  'Liberia',
  'Libya',
  'Macedonia',
  'Maldives',
  'Mali',
  'Nicaragua',
  'Serbia',
  'Montenegro',
  'Somalia',
  'South Sudan',
  'Sudan',
  'Tunisia',
  'Ukraine',
  'Venezuela',
  'Yemen',
  'Zimbabwe',
]

// Hashed domains using SHA-256 (pre-computed)
export const HASHED_DOMAINS = [
  'd4dd8e5952efb8e2101186a181790e64edf8bf838bfa10ad8e7788e72542b12f',
  '0da6e3d6ff5458f08e0c7516ee74e9b66373b85f386e64c13dd4bd75cf25b1d2',
  'e4eb3c361dcdd91fb0a26e32ac81ff47e2e2056fc0d138349a913ace3bc8390d',
]
